/**
 * Admin identity helper.
 *
 * Single source of truth for the admin allowlist — mirrors
 * backend/sherlock/config.py:Settings.admin_emails. Swappable here without
 * a backend change: update ADMIN_EMAILS and rebuild.
 *
 * Note: domain is detectinspections.com (with the 's').
 */

export const ADMIN_EMAILS = [
  'mohit@detectinspections.com',
  'akshay.dadwal@detectinspections.com',
] as const;

/**
 * Returns true when the supplied email is on the admin allowlist.
 * Accepts null / undefined so callers can safely pass `user?.email`.
 */
export function isAdminEmail(email: string | null | undefined): boolean {
  return email != null && (ADMIN_EMAILS as readonly string[]).includes(email);
}
